<script setup lang="ts">
import { GTMContentGroup } from '~/lib/models/gtm'

definePageMeta({
  alias: ['/cardapio'],
})

const appStore = useAppStore()
const { trackPageView } = useGTM()
const { fetchStaticCategories } = useMenu()

await useWrapperKeyAsyncData('staticCategories', () => fetchStaticCategories())

onMounted(async () => {
  trackPageView({
    cg: GTMContentGroup.primary.OUR_MENU,
  })
})
</script>

<template>
  <StaticMenuView v-if="appStore.staticCategories" :categories="appStore.staticCategories" />
</template>
